import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './store';

interface CompactMenuState {
  value: boolean;
}

/** Side menu is permanently expanded — compact mode is disabled. */
const initialState: CompactMenuState = {
  value: false,
};

export const compactMenuSlice = createSlice({
  name: 'compactMenu',
  initialState,
  reducers: {
    setCompactMenu: (state, action: PayloadAction<boolean>) => {
      state.value = false;
      void action;
    },
  },
});

export const { setCompactMenu } = compactMenuSlice.actions;

export const selectCompactMenu = (_state: RootState) => false;

export default compactMenuSlice.reducer;
